/* Totals derived from history rows.

   This mirrors recompute_item_totals() in migration 0002 exactly. The database
   is authoritative — it recomputes on every history edit — but the UI applies
   the same result optimistically so a tap feels instant. If the two ever
   disagree, the server's answer wins on the next response. */

export function derivedTotals(history) {
  const latest = (action) => {
    const dates = history.filter((h) => h.action === action).map((h) => h.date).sort();
    return dates.length ? dates[dates.length - 1] : null;
  };

  return {
    wears: history.filter((h) => h.action === "Worn").length,
    lastWorn: latest("Worn"),
    lastCleaned: latest("Cleaned"),
    lastRotated: latest("Rotated"),
  };
}

/** Newest first — the order the Flight History list reads best in. */
export function sortedHistory(history) {
  return [...history].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
}
